document.addEventListener('DOMContentLoaded', function () {
    var menuLeft = document.querySelector('.menu-inside-left');
    if (!menuLeft) return;

    var collapsibleElements = document.querySelectorAll('.collapse');

    collapsibleElements.forEach(function (element) {
        element.addEventListener('show.bs.collapse', function () {
            var button = document.querySelector('[data-bs-target="#' + element.id + '"]');
            var icon = button.querySelector('.fa-chevron-down.toggle');
            if (icon) {
                icon.classList.add('rotated');
            }
        });

        element.addEventListener('hide.bs.collapse', function () {
            var button = document.querySelector('[data-bs-target="#' + element.id + '"]');
            var icon = button.querySelector('.fa-chevron-down.toggle');
            if (icon) {
                icon.classList.remove('rotated');
            }
        });
    });
});